// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1oAlT","question":"Question_question__2D5n1","description":"Question_description__2CQLR"};